import { render, staticRenderFns } from "./MobileConsultingServices.vue?vue&type=template&id=631d4fdc&scoped=true"
import script from "./MobileConsultingServices.vue?vue&type=script&lang=js"
export * from "./MobileConsultingServices.vue?vue&type=script&lang=js"
import style0 from "./MobileConsultingServices.vue?vue&type=style&index=0&id=631d4fdc&prod&lang=css"
import style1 from "./MobileConsultingServices.vue?vue&type=style&index=1&id=631d4fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631d4fdc",
  null
  
)

export default component.exports